import { render, staticRenderFns } from "./basics.vue?vue&type=template&id=33996f24&scoped=true"
import script from "./basics.vue?vue&type=script&lang=js"
export * from "./basics.vue?vue&type=script&lang=js"
import style0 from "./basics.vue?vue&type=style&index=0&id=33996f24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33996f24",
  null
  
)

export default component.exports